<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/D9tIrn/tc-custom/9781526763792.jpg?1705212302811" alt="This image is the cover for the book Flight Through the Ages"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Flight Through the Ages
      </h1>
      <p class="bookDescription body article font2">
        <p>Flight Through the Ages was the title of the first annual exhibition of the Guild of Aviation Artists in 1971. This book celebrates 50 years of exhibitions and includes paintings by almost one hundred Guild artists, past and present, depicting aircraft from the earliest airborne activities through to the present day. There are balloons and airships, fighters and bombers from both world wars, including Spitfires and Lancasters, airliners from the early years of air travel through Concorde and on to the present day. There are also gliders and helicopters and the current generation of advanced aircraft among some 200 illustrations, most in full color.  Artists include some of the most well-known British artists of their day and the works display imagination and creativity in a variety of different styles and treatments that bring flying machines to life. There are historical scenes and aircraft in their natural environment, showing action and some of the aviators and others from the world of aviation. There is a short history of the Guild and a step-by-step guide to one artist’s approach to the subject.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Artists of Aviation
      </h2>
      
      <p class="authorDescription body article">The Guild of Aviation Artists is recognised throughout the world as the premier society for the promotion of aviation art. The Guild brings together the worlds of art and aviation. The Guild’s principle aim is to promote aviation art in all its forms and to encourage interest in the genre by artists and non-artists alike. Every Summer, the Guild stages ‘Aviation Paintings of the Year’, a major exhibition at the prestigious Mall Galleries in Central London where some 400 works go on show. It is the largest exhibition of its kind in the world.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword/Pen and Sword Transport
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?455c9724